import type { AxiosInstance } from "axios";
import { apiClient } from "@/data/axiosConfig";

export interface InsuranceSearchRequest {
  licencePlate: string;
}

export interface InsuranceSearchResponse {
  result: InsuranceResult | null;
}

export interface InsuranceResult {
  data: Record<string, any>;
}

export function createInsuranceSearchApi(client: AxiosInstance) {
  return {
    search: async (request: InsuranceSearchRequest): Promise<InsuranceSearchResponse> => {
      const response = await client.post<InsuranceSearchResponse>("/api/insurance-search", request);
      return response.data;
    },
  };
}

export const insuranceSearchApi = createInsuranceSearchApi(apiClient);

